import StatusIndicator from "glesys-controlpanel/components/status-indicator";
import IconsPackage from "glesys-controlpanel/components/icons/package";
import IconsMap from "glesys-controlpanel/components/icons/map";
import IconsWrench from "glesys-controlpanel/components/icons/wrench";
import dataCenterNiceName from "glesys-controlpanel/helpers/data-center-nice-name";
import MaintenanceWindow from "glesys-controlpanel/components/maintenance-window";

<template>
  <StatusIndicator class="h-4" data-test-database-status @status={{@database.statusIndicator}} @showLabel={{true}} />
  <div class="flex items-center gap-1.5 whitespace-nowrap" data-test-database-engine>
    <IconsPackage class="size-4 stroke-gray-400 stroke-[1.5]" />
    {{@database.normalizedEngineName}}
    {{@database.engineversion}}
  </div>
  <div class="flex items-center gap-1.5 whitespace-nowrap" data-test-database-data-center>
    <IconsMap class="size-6 stroke-gray-400 stroke-[1.5]" />
    {{dataCenterNiceName @database.datacenterkey @dataCenters}}
  </div>
  <div class="flex items-center gap-1.5 whitespace-nowrap" data-test-database-maintenance>
    <IconsWrench class="size-6 stroke-gray-400 stroke-[1.5]" />
    <MaintenanceWindow @value={{@database.maintenancewindow}} @simple={{true}} />
  </div>
</template>
